$('.confirm-lock').on('click', function (e) {
    e.preventDefault();
    let link = $(this).attr('href');
    showPrintSweetAlert(link);
});

function showPrintSweetAlert(link) {
    Swal.fire({
        title: 'Sicherheitsabfrage',
        icon: 'warning',
        text: 'Soll die Positionsbearbeitung wirklich abgeschlossen werden?',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Nein',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ja',
        cancelButtonColor: '#d33'
    }).then((result) => {
        if (result.value) {
            window.location.href = link
        }
    });
}
